import React, { Component } from 'react';

class Settings extends Component {
  render() {
    return (
      <section>
        <h1 data-testid="settings-title">Configurações</h1>
      </section>
    );
  }
}

export default Settings;
